// extracted by mini-css-extract-plugin
export var card = "_6y-0";
export var expandedCard = "_6y-2";
export var paginated = "_6y-1";